import { AxiosResponse, AxiosError } from 'axios';

import { GENERIC_ERROR_MESSAGE } from 'features/video-conference/constants';
import { isProd } from 'features/video-conference/utils';
import { captureException, captureMessage } from 'shared/utils/handlerErrors';
import { hasEnvelopedData } from 'features/video-conference/services/utils';

function unauthorizedInterceptor(error: AxiosError) {
  const { request, response } = error;

  if (isProd && response?.status === 401) {
    captureMessage(`Request: ${request?.responseURL} - forced logout`);
    return Promise.reject(response);
  }

  return null;
}

export const interceptorResponseTransformData = (response: AxiosResponse) => {
  try {
    const responseData = hasEnvelopedData(response)
      ? response.data.data
      : response.data;
    const getResponseData = {
      getResponseData: () => responseData,
    };
    return Object.assign(response, getResponseData);
  } catch (e) {
    captureException(e);
    return response;
  }
};

export const interceptorResponseErrors = async (error: AxiosError) => {
  if (!error.response) return error;
  try {
    await unauthorizedInterceptor(error);
  } catch (e) {
    captureException(e);
  }

  const responseErrors = error?.response?.data?.errors;
  const getResponseErrors = {
    errors: responseErrors || [{ message: GENERIC_ERROR_MESSAGE }],
  };

  return Object.assign(error.response, getResponseErrors);
};
